import update from 'immutability-helper';
import _ from 'lodash';
import { routerRedux } from 'dva/router';
import { deserialise } from '~/utils/jsonApi/deserialise';
import ApiClient from '~/services/client';
import { getPageInfo } from '../utils/table';
import initialState from './initialStates/resource';

const resource = 'templates';

export default {
  namespace: resource,
  state: initialState,
  effects: {
    *fetch({ payload }, { call, put }) {
      const { pageNumber, sortField, sortOrder, searchQuery } = payload;
      const response = yield call(ApiClient.templates.search, pageNumber, sortField, sortOrder, searchQuery);
      yield put({
        type: 'readResource',
        payload: response,
      });
    },
    *create({ payload }, { call, put }) {
      const { params } = payload;
      const response = yield call(ApiClient.templates.create, params);
      yield put({
        type: 'createResource',
        payload: response,
      });
      yield put(routerRedux.push(`/library/templates/${response.data.id}`));
    },
    *read({ payload }, { call, put }) {
      const { id } = payload;
      const response = yield call(ApiClient.templates.read, id);
      yield put({
        type: 'currentResource',
        payload: response,
      });
    },
    *update({ payload }, { call, put }) {
      const { id, params } = payload;
      const response = yield call(ApiClient.templates.update, id, params);
      yield put({
        type: 'updateResource',
        payload: response.data,
      });
      if (response) {
        yield put({
          type: 'read',
          payload: response.data,
        });
      }
    },
    *delete({ payload }, { call, put }) {
      const { id } = payload;
      yield call(ApiClient.templates.delete, id);
      yield put({
        type: 'deleteResource',
        payload: { id },
      });
      yield put({
        type: 'fetch',
        payload: { id },
      });
      yield put(routerRedux.push('/library/templates'));
    },
    *applyTemplate({ payload }, { call, put }) {
      const { care_plan_id } = payload;
      const response = yield call(ApiClient.templates.applyTemplate, payload);
      if (response) {
        yield put({
          type: 'appliedTemplate',
          payload: response.data,
        });
        yield put({
          type: 'care_plans/read',
          payload: {
            id: care_plan_id,
          },
        });
      }
    },
  },
  reducers: {
    readResource(state, action) {
      const { links } = action.payload;
      const { pageNumber, pageSize, total, sortField, sortOrder, searchQuery } = getPageInfo(links);
      const deserialisedData = deserialise(action.payload);
      return {
        ...state,
        list: deserialisedData.data,
        pageNumber,
        pageSize,
        total,
        sortField,
        sortOrder,
        searchQuery,
      };
    },
    createResource(state) {
      return {
        ...state,
      };
    },
    updateResource(state, action) {
      const { id, attributes } = action.payload;
      const index = _.findIndex(state.list, { id });
      return {
        ...state,
        list: update(state.list, { $splice: [[index, 1, action.payload]] }),
        resource: attributes,
      };
    },
    currentResource(state, action) {
      const deserialisedData = deserialise(action.payload);
      return {
        ...state,
        resource: deserialisedData.data,
      };
    },
    deleteResource(state) {
      return {
        ...state,
      };
    },
    appliedTemplate(state) {
      return {
        ...state,
      };
    },
  },
};
